import styled from 'styled-components';

export const BalanceOnHandThresholdsContainerStyle = styled.div`
  .fkTuFL {
    max-height: 15.1em;
  }
`;
